module.exports = __webpack_public_path__ + "img/emoji_27.8fd9f6ea.png";